__webpack_require__.p = "/smart-nfc-card/";